'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require('styled-components');

/**
 * A simple slide transition.
 *
 * @public
 * @property {Array} normal
 *   Transition from left to right
 * @property {Array} reverse
 *   Transition from right to left
 * @property {Array} up
 *   Transition upwards
 * @property {Array} down
 *   Transition downwards
 */
var slide = {
  normal: (0, _styledComponents.css)(['transform:translate3d( calc( -100% * var(--direction,-1) * (var(--regulator,0) - var(--time,1)) ),0,0 );']),
  reverse: (0, _styledComponents.css)(['transform:translate3d( calc( 100% * var(--direction,-1) * (var(--regulator,0) - var(--time,1)) ),0,0 );']),
  down: (0, _styledComponents.css)(['transform:translate3d( 0,calc( -100% * var(--direction,-1) * (var(--regulator,0) - var(--time,1)) ),0 );']),
  up: (0, _styledComponents.css)(['transform:translate3d( 0,calc( 100% * var(--direction,-1) * (var(--regulator,0) - var(--time,1)) ),0 );'])
};

exports.default = slide;